<div class="modal-header">
  <h3 class="modal-title">{{ 'priceSupportAgreement.acceptAgreement' | cxTranslate }}</h3>

  <button type="button" class="close closeModal" aria-label="Close" (click)="modal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="row agreement">
    <div class="col">
      <div>
        <span class="agreement-label">{{ 'priceSupportAgreement.agreementNUM' | cxTranslate }}</span>
        <span class="agreement-value">{{ data?.agreement?.orderCode }}</span>
      </div>
      <div>
        <span class="agreement-label">{{ 'shared.name' | cxTranslate }}</span>
        <span class="agreement-value">{{ data?.agreement?.endCustomer?.orgUnit?.name }}</span>
      </div>
      <div>
        <span class="agreement-label">{{ 'shared.startDate' | cxTranslate }}</span>
        <span class="agreement-value">{{ data?.agreement?.startDate | cxDate: 'longDate' }}</span>
      </div>
      <div>
        <span class="agreement-label">{{ 'shared.endDate' | cxTranslate }}</span>
        <span class="agreement-value">{{ data?.agreement?.obligationEndDate | cxDate: 'longDate' }}</span>
      </div>
    </div>
    <div class="col-auto agreement-extra">
      @if (data?.showDetails) {
        <button
          type="button"
          class="btn btn-primary agreement-extra-detail"
          (click)="onShowDetails()"
          >
          {{ 'shared.viewDetails' | cxTranslate }}
        </button>
      }
      @if (data?.agreement?.externalQuoteDocumentBlob) {
        <button
          type="button"
          class="btn btn-primary btn-small agreement-extra-tc"
          (click)="getTermsAndConditions(data?.agreement)"
          >
          <i class="fa fa-download"></i>
          {{ 'priceSupportAgreement.t_c' | cxTranslate }}
        </button>
      }
    </div>
  </div>

  <form id="acceptForm" (ngSubmit)="onSubmit()" [formGroup]="acceptForm">
    <div class="form-group">
      <label>
        <div class="form-group-control">
          <span class="label-content">{{ 'priceSupportAgreement.acceptor' | cxTranslate }}</span>
          <input
            type="email"
            class="form-control"
            formControlName="email"
            placeholder="{{ 'loginForm.emailAddress.placeholder' | cxTranslate }}"
            />
          </div>
          <div class="form-group-errors">
            <cx-form-errors [control]="acceptForm.get('email')"></cx-form-errors>
          </div>
        </label>
      </div>
    </form>
  </div>

  <div class="modal-footer agreement-action">
    @if (data?.agreement?.externalQuoteDocumentBlob) {
      <p>
        {{ 'priceSupportAgreement.messageTC' | cxTranslate }}
        <span (click)="getTermsAndConditions(data?.agreement)">{{ 'priceSupportAgreement.t_c' | cxTranslate }}</span>
      </p>
    }
    <div class="agreement-action-btn">
      <app-custom-button
        [title]="'priceSupportAgreement.accept' | cxTranslate"
        [showSpinner]="showSpinner"
        styleClass="agreement-action-accept"
        (clicked)="onSubmit()"
      ></app-custom-button>
    </div>
  </div>
